import { uniqueId } from "lodash";
import { groupBy } from "../../utils/Array"
import { useCallback, useState } from "react"
import moment from "moment";
import ModalAlteracaoConta from "./modalAlteracaoConta";

const TabelaPendentes = ({ lancamentos, acc, esteiraID, setLancamentos }: { lancamentos: any[], acc: string, esteiraID: number, setLancamentos: Function }) => {

    const [modalAlterarConta, setModalAlterarConta] = useState(false);
    const [idAlteracao, setIdAlteracao] = useState(0);

    const classificarDescricao = useCallback((codigo, tipo, tipoLancamentoExtrato, regra) => {
        if (!tipoLancamentoExtrato)
            return "";

        if (codigo === acc) {
            return regra && regra.includes("Extrato") ? "Extrato importado" : regra;
        } else {
            if (tipoLancamentoExtrato === tipo) {
                return "Provisão encontrada";
            }

            return "Lançamento gerado";
        }

    }, [acc])

    return (
        <div className='row'>
            <ModalAlteracaoConta atualizarLancamentos={(lancamento: any) => {
                setLancamentos((old: any) => {
                    const cp = [...old]
                    const index = cp.findIndex(f => f.id === lancamento.id)
                    if (index >= 0) {
                        cp[index].codigoContabil = lancamento.codigoContabil;
                        cp[index].descricaoCodigoContabil = lancamento.descricaoCodigoContabil;
                    }

                    return cp;
                })
            }} toggleModal={() => setModalAlterarConta((old) => !old)} show={modalAlterarConta} contaAtual={acc} id={idAlteracao} esteiraID={esteiraID} />
            <div className="col-md-12">
                <h2>Lançamentos Pendentes</h2>
            </div>
            <div className='col-md-12'>
                {lancamentos && Object.keys(groupBy(lancamentos, 'chaveVinculo')).map((item: any) => (
                    <div className="row mt-2" style={{ padding: '5px', border: '1px solid grey', borderRadius: '5px' }} key={uniqueId()}>
                        <div className="col-md-12">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col">Conta</th>
                                        <th scope="col">Data</th>
                                        <th scope="col">Histórico</th>
                                        <th scope="col">Valor</th>
                                        <th scope="col">Tipo</th>
                                        <th scope="col">Descrição</th>
                                        <th scope="col">#</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {lancamentos.filter(f => f.chaveVinculo === item).map((item2) => (
                                        <tr>
                                            <th scope="row">{item2.codigoContabil} - {item2.descricaoCodigoContabil}</th>
                                            <th>{moment(item2.dataLancamento).format('DD/MM/YYYY')}</th>
                                            <th>{item2.historico}</th>
                                            <th>{item2.valorProvisaoRecolher.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}</th>
                                            <th>{item2.tipoLancamento}</th>
                                            <th>{classificarDescricao(item2.codigoContabil, item2.tipoLancamento, lancamentos.find(f => f.chaveVinculo === item && f.codigoContabil === acc)?.tipoLancamento, item2.tipoRegra)}</th>
                                            {classificarDescricao(item2.codigoContabil, item2.tipoLancamento, lancamentos.find(f => f.chaveVinculo === item && f.codigoContabil === acc)?.tipoLancamento, item2.tipoRegra) === 'Lançamento gerado' ? (
                                                <th><button className="btn btn-danger" onClick={() => {
                                                    setModalAlterarConta((old) => {
                                                        return !old;
                                                    });

                                                    setIdAlteracao(item2.id);
                                                }}>Alterar</button></th>
                                            ) : (
                                                <th></th>
                                            )}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default TabelaPendentes